export default __webpack_public_path__ + "static/media/redo.b99f4b8c.svg";